import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-save-success',
  templateUrl: './modal-save-success.component.html',
  styleUrls: ['./modal-save-success.component.scss']
})
export class ModalSaveSuccessComponent implements OnInit {
  icon: any;
  labelTitile: string;
  onAdd = new EventEmitter();


  constructor(@Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel) {

    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }

  }

  ngOnInit() {

  }

}
